import styled from "styled-components";

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`
const Label = styled.p`
    font-size: 14px;
    font-weight: 500;
    color: #555;
    margin: 0 0 5px 5px;
`
const Input = styled.div`
    width: 100%;
    display: flex;
    min-height: 40px;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 9px;
    background-color: #f6f8fa;
    border: 1px solid #ccc;
    box-sizing: border-box;
`
const Valor = styled.p`
    font-size: 14px;
    margin: 0;
    color: #333;
    margin: 0;
`

const ViewContainer = ({ label, valor }) => {

    return(
        <>
            <Container>
                <Label>{label}</Label>
                <Input>
                    <Valor>{valor}</Valor>
                </Input>
            </Container>
        </>
    )
}

export default ViewContainer;